var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sensor-config-page"},[_c('RouterMenu'),_c('div',{staticClass:"sensor-content"},[_c('Sensor')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }